<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              :placeholder="placeholderbaslangic"
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbitis"
              v-model="datepickerbitis"
              :placeholder="placeholderbitis"
              local="en"
              today-variant="danger"
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="getOrderList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-row>
              <b-col>
                <vs-button style="border-radius: 5px" @click="getOrderList()"
                  >Listele</vs-button
                >
              </b-col>
              <b-col>
                <vs-button style="border-radius: 5px" @click="excelIndir()"
                  >Excel</vs-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <b-row>
      <b-col>
        <vs-card>
          <ag-grid-vue
            v-if="!isMobile()"
            style="width: 100%; height: 500px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="orderListClmn"
            :rowData="orderList"
            :localeText="localeText"
            :rowSelection="rowSelection"
            @grid-ready="onGridReady"
            :rowClassRules="rowClassRules"
            :suppressCopyRowsToClipboard="true"
          >
          </ag-grid-vue>

          <div
            v-else
            class="items-list-view"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <vx-card
              class="list-view-item overflow-hidden"
              v-on="$listeners"
              style="margin-bottom: 10px"
            >
              <template slot="no-body">
                <div class="item-details no-gutter" style="padding: 15px">
                  <b-row style="margin-bottom: 20px">
                    <b-col> Sipariş Numarası: {{ item.OrderNumber }} </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="3">
                      <vs-avatar
                        style="background-color: #c29d76"
                        icon-pack="feather"
                        icon="icon-calendar"
                        size="large"
                      />
                    </b-col>
                    <b-col cols="9">
                      <h4>
                        {{ getDay(item.OrderDate) }} {{ getMounth(item.OrderDate) }}
                      </h4>
                      <h6>
                        {{ getYear(item.OrderDate) }}
                      </h6>
                    </b-col>
                    <b-col cols="3" v-if="item.Desctription != ''">
                      <vs-avatar
                        style="background-color: #c29d76"
                        icon="place"
                        size="large"
                      />
                    </b-col>
                    <b-col cols="9" v-if="item.Desctription != ''">
                      <h4>
                        {{ item.Desctription }}
                      </h4>
                    </b-col>
                    <b-col cols="3">
                      <vs-avatar
                        style="background-color: #c29d76"
                        icon="search"
                        size="large"
                      />
                    </b-col>
                    <b-col cols="9" style="padding-top: 10px">
                      <h5>Sipariş Adedi: {{ item.TOTALQUANTITY }}</h5>
                      <h5>Sipariş Tutarı: {{ parseCurrency(item.TOTAL) }}</h5>
                      <h5>KDV Tutarı: {{ parseCurrency(item.VATTOTAL) }}</h5>
                      <h5>Tamamlanan Adet: {{ item.COMPLATEQUANTITY }}</h5>
                      <h5>Tamamlanan Tutar: {{ parseCurrency(item.COMPLATETOTAL) }}</h5>
                      <h5>Sipariş Yükleme Termini: {{ parseDate(item.TERMIN) }}</h5>
                      <h5>Sipariş Ödeme Vadesi: {{ parseDate(item.Vade) }}</h5>
                      <div v-if="item.DurumId == '1'">
                        <vs-chip color="danger"> Onay Bekleniyor </vs-chip>
                      </div>
                      <div v-else-if="item.durum == '2'">
                        <vs-chip color="success"> İşleme alındı </vs-chip>
                      </div>
                      <div v-else-if="item.durum == '3'">
                        <vs-chip color="warning"> Kargoya Gönderildi </vs-chip>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <vs-button
                      icon-pack="feather"
                      icon="icon-chevrons-right"
                      icon-after
                      class="shadow-md w-full lg:mt-0 mt-4"
                      @click="getOrderListDetay(item)"
                      >Detay</vs-button
                    >
                  </b-row>
                </div>
              </template>
            </vx-card>
          </div>
        </vs-card>
      </b-col>
    </b-row>

    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      title="Rapor Detayı"
      hide-footer
    >
      <div id="invoice-page" style="min-height: 350px">
        <div class="items-center justify-between">
          <div class="items-center">
            <vs-card>
              <h4 style="color: #7c6144">
                Sipariş Referans Numarası: {{ siparisRefNo }}
              </h4>
            </vs-card>

            <vs-tabs alignment="left" color="primary" v-if="!isMobile()">
              <vs-tab label="Detay" icon="list_alt">
                <b-row align-h="end">
                  <b-col cols="12" md="auto" style="padding: 0"
                    ><vs-button
                      v-on:click="onBtPdf()"
                      style="
                        margin: 5px 0px;
                        font-weight: bold;
                        border-radius: 5px;
                        width: 100%;
                      "
                    >
                      Pdf indir
                    </vs-button>
                  </b-col>
                  <b-col cols="12" md="auto" style="padding: 0"
                    ><vs-button
                      v-on:click="onBtExport()"
                      style="
                        margin: 5px 0px;
                        font-weight: bold;
                        border-radius: 5px;
                        width: 100%;
                      "
                    >
                      Excel indir
                    </vs-button>
                  </b-col>
                </b-row>

                <vs-card>
                  <b-form-input
                    v-model="arananDetayDegeri"
                    @keyup.enter="getOrderListDetay()"
                    id="smallInput"
                    placeholder="Arama..."
                  />

                  <ag-grid-vue
                    style="width: 100%; height: 500px"
                    class="ag-theme-alpine"
                    :defaultColDef="defaultColDef"
                    :columnDefs="orderListColumn"
                    :rowData="orderListDetay"
                    :localeText="localeText"
                    :rowSelection="rowSelection"
                    :excelStyles="excelStyles"
                    :defaultExcelExportParams="defaultExcelExportParams"
                    :pinnedBottomRowData="pinnedBottomRowData"
                    @grid-ready="onGridReady2"
                    :popupParent="popupParent"
                    :suppressCopyRowsToClipboard="true"
                  >
                  </ag-grid-vue>
                </vs-card>
              </vs-tab>
              <vs-tab
                @click="kargoDurumSorgula"
                label="Kargo Durumu"
                icon="local_shipping"
              >
                <vs-card>
                  <b-row>
                    <b-col cols="6">
                      <vs-card>
                        <b-form-group label-for="renk">
                          <blockquote
                            style="
                              margin: 0px !important;
                              padding-left: 15px;
                              border-left: 4px solid #7367f0;
                            "
                          >
                            <b-row>
                              <b-col>
                                <vs-chip color="success">
                                  Kargo Durumu: {{ kargoDurumu }}
                                </vs-chip>
                              </b-col>
                            </b-row>

                            <br />
                            <h6>Kargo Takip Kodu: {{ kargoTakipKodu }}</h6>
                            <h6>
                              Kargo Takip Url:
                              <a :href="karkoTakipUrl" target="_blank">Tıklayınız</a>
                            </h6>

                            <h6>Kargoya Veriliş Tarihi: {{ kargoyaVerilisTarihi }}</h6>
                            <h6>
                              Kargo Durum Güncellenme Tarihi:
                              {{ durumGuncellenmeTarihi }}
                            </h6>
                            <h6>Teslimat Seri Numarası: {{ teslimatSeriNumarasi }}</h6>
                          </blockquote>
                        </b-form-group>
                      </vs-card>
                    </b-col>
                    <b-col cols="6">
                      <vs-card>
                        <b-form-group label-for="renk">
                          <blockquote
                            style="
                              margin: 0px !important;
                              padding-left: 15px;
                              border-left: 4px solid #7367f0;
                            "
                          >
                            <h6>Kargo Adres: {{ kargoAdres }}</h6>
                            <h6>Kargo Ad Bilgisi {{ kargoAd }}</h6>
                            <h6>Kargoya İl/İlçe: {{ kargoIl }}/{{ kargoIlce }}</h6>
                            <h6>Teslimat Tipi: {{ teslimatTipi }}</h6>
                            <h6>Ödeme Tipi: {{ odemeTipi }}</h6>
                            <h6>Toplam Tutar: {{ toplamTutar }}</h6>
                            <h6>Toplam Kg Desi: {{ toplamkgDesi }}</h6>
                          </blockquote>
                        </b-form-group>
                      </vs-card>
                    </b-col>
                  </b-row>
                </vs-card>
              </vs-tab>
            </vs-tabs>

            <vs-tabs v-else color="primary" alignment="center">
              <vs-tab label="Detay" icon="list_alt">
                <b-form-input
                  v-model="arananDetayDegeri"
                  @keyup.enter="getOrderListDetay()"
                  id="smallInput"
                  placeholder="Arama..."
                />
                <div
                  class="items-list-view"
                  v-for="(item, index) in orderListDetay"
                  :key="index"
                >
                  <vx-card
                    class="list-view-item overflow-hidden"
                    v-on="$listeners"
                    style="margin-bottom: 10px"
                  >
                    <template slot="no-body">
                      <div class="item-details no-gutter">
                        <b-row>
                          <b-col lg="2" sm="6" md="2" xl="2">
                            <div
                              class="w-full item-img-container bg-white flex items-center justify-center cursor-pointer"
                            >
                              <img
                                :src="sistemurl + item.images"
                                :alt="item.maddeAciklamasi"
                                class="grid-view-img"
                                style="max-height: 90px"
                                @click="
                                  $router
                                    .push({
                                      name: 'ecommerce-item-detail-view',
                                      params: { item_id: item.maddeKodu },
                                    })
                                    .catch(() => {})
                                "
                              />
                            </div>
                          </b-col>
                          <b-col lg="8" sm="6" md="8" xl="8">
                            <div class="">
                              <div class="p-4 pt-6">
                                <slot name="item-meta">
                                  <h6
                                    class="item-name font-semibold mb-1 hover:text-primary cursor-pointer"
                                    @click="
                                      $router
                                        .push({
                                          name: 'ecommerce-item-detail-view',
                                          params: { item_id: item.maddeKodu },
                                        })
                                        .catch(() => {})
                                    "
                                  >
                                    <h5 style="text-align: center; color: #7c6144">
                                      {{ item.maddeAciklamasi }}
                                    </h5>
                                    <h6>Stok Kodu: {{ item.maddeKodu }}</h6>
                                    <h6>Beden: {{ item.BEDEN }}</h6>
                                    <h6>Renk: {{ item.renkAciklamasi }}</h6>
                                    <h6 style="text-align: right">
                                      Fiyat: {{ currencyFormatter(item.FIYAT) }}
                                    </h6>
                                    <h6 style="text-align: right">
                                      Miktar: {{ item.MIKTAR }}
                                    </h6>
                                    <h6 style="text-align: right">
                                      Tutar: {{ currencyFormatter(item.TUTAR) }}
                                    </h6>
                                  </h6>
                                </slot>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </vx-card>
                </div>
              </vs-tab>
              <vs-tab
                label="Kargo Durumu"
                @click="kargoDurumSorgula"
                icon="local_shipping"
              >
                <vs-card>
                  <b-row>
                    <b-col cols="12">
                      <vs-card>
                        <b-form-group label-for="renk">
                          <blockquote
                            style="
                              margin: 0px !important;
                              padding-left: 15px;
                              border-left: 4px solid #7367f0;
                            "
                          >
                            <b-row>
                              <b-col>
                                <vs-chip color="success">
                                  Kargo Durumu: {{ kargoDurumu }}
                                </vs-chip>
                              </b-col>
                            </b-row>

                            <br />
                            <h6>Kargo Takip Kodu: {{ kargoTakipKodu }}</h6>
                            <h6>
                              Kargo Takip Url:
                              <a :href="karkoTakipUrl" target="_blank">Tıklayınız</a>
                            </h6>

                            <h6>Kargoya Veriliş Tarihi: {{ kargoyaVerilisTarihi }}</h6>
                            <h6>
                              Kargo Durum Güncellenme Tarihi:
                              {{ durumGuncellenmeTarihi }}
                            </h6>
                            <h6>Teslimat Seri Numarası: {{ teslimatSeriNumarasi }}</h6>
                          </blockquote>
                        </b-form-group>
                      </vs-card>
                    </b-col>
                    <b-col cols="12">
                      <vs-card>
                        <b-form-group label-for="renk">
                          <blockquote
                            style="
                              margin: 0px !important;
                              padding-left: 15px;
                              border-left: 4px solid #7367f0;
                            "
                          >
                            <h6>Kargo Adres: {{ kargoAdres }}</h6>
                            <h6>Kargo Ad Bilgisi {{ kargoAd }}</h6>
                            <h6>Kargoya İl/İlçe: {{ kargoIl }}/{{ kargoIlce }}</h6>
                            <h6>Teslimat Tipi: {{ teslimatTipi }}</h6>
                            <h6>Ödeme Tipi: {{ odemeTipi }}</h6>
                            <h6>Toplam Tutar: {{ toplamTutar }}</h6>
                            <h6>Toplam Kg Desi: {{ toplamkgDesi }}</h6>
                          </blockquote>
                        </b-form-group>
                      </vs-card>
                    </b-col>
                  </b-row>
                </vs-card>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </b-modal>
    <OrdersPdf ref="siparisCek" />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { isMobile } from "mobile-device-detect";
import Store from "../../store/store";
import state from "../../store/state";
import moment from "moment";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer";
import UrunResimCellRenderer from "./CellRenderers/UrunResimCellRenderer";
import KdvliFiyatCellRenderer from "./CellRenderers/KdvliFiyatCellRenderer";
import jsonData from "../../../public/user.json";
import OrdersPdf from "../components/b2b-components/OrdersPdf.vue";
import userJson from "../../../public/user.json";
import * as XLSX from "xlsx";
import OrderDetailCellRenderer from "./CellRenderers/OrderDetailCellRenderer.vue";
let siparisRefNo = "",
  ACT_NAME = "",
  OrderDateF = "",
  adresF = "",
  taxnumberF = "",
  taxnumbF = "";

const getRows = () => [
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: jsonData.imageUtils,
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: "",
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "coverHeading3",
      data: {
        value: "Proforma Fatura Ve Sipariş Formu",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "tarihHeading",
      data: {
        value: "Tarih:",
        type: "String",
      },
      mergeAcross: 10,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: OrderDateF,
        type: "String",
      },
    },
  ],
  [
    {
      styleId: "tarihHeading",
      data: {
        value: "Sipariş No:",
        type: "String",
      },
      mergeAcross: 10,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: siparisRefNo,
        type: "String",
      },
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Satıcı:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: jsonData.excelSatici,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Satıcı Adres:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: jsonData.excelSaticiAdres,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Alıcı:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: ACT_NAME,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Alıcı Adres:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: adresF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Vergi Dairesi:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: taxnumberF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Vergi No:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: taxnumbF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [],
];
const getRowsHeader = () => [
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: "",
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: "",
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: jsonData.imageUtils,
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "imageStyle",
      data: {
        type: "String",
        value: "",
      },
      mergeAcross: 11,
    },
  ],
  [
    {
      styleId: "coverHeading3",
      data: {
        value: "Proforma Fatura Ve Sipariş Formu",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "tarihHeading",
      data: {
        value: "Tarih:",
        type: "String",
      },
      mergeAcross: 10,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: OrderDateF,
        type: "String",
      },
    },
  ],
  [
    {
      styleId: "tarihHeading",
      data: {
        value: "Sipariş No:",
        type: "String",
      },
      mergeAcross: 10,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: siparisRefNo,
        type: "String",
      },
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Satıcı:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: jsonData.excelSatici,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Satıcı Adres:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: jsonData.excelSaticiAdres,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Alıcı:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: ACT_NAME,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Alıcı Adres:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: adresF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Vergi Dairesi:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: taxnumberF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "Vergi No:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeading2",
      data: {
        value: taxnumbF,
        type: "String",
      },
      mergeAcross: 10,
    },
  ],
  [],
  [
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Grup",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Barkod",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Stok Kodu",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Stok Adı",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Renk",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Beden",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Sipariş \n Adedi",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Toptan\n Satış \nFiyatı TL \n(KDV HARİÇ)",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Toptan \nSatış \nFiyatı TL \n(KDV DAHİL)",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Toptan\n Sipariş \nTutarı \n(KDV HARİÇ)",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "Toptan Sipariş Tutarı (KDV DAHİL)",
      },
    },
    {
      styleId: "header",
      data: {
        type: "String",
        value: "PERAKENDE SATIŞ FİYATI",
      },
    },
  ],
];
const getRowsF = () => [
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "ŞARTLAR",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "1- Toplam siparişteki miktarın toleransı +/- 10%'dur.",
        type: "String",
      },
      mergeAcross: 11,

      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "2- Etiket ve paketleme: Buldan's etiketli. Çoklu paketleme.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "3- Teslimat detayları: 01.04.2023 Tarihinden itibaren başlayacak, 30.06.2023 tarihinde son bulacaktır. ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "10.000 TL ve üstü kargolarda Nakliye ve sigorta alıcıya aittir. ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "4- Ödeme şekli: %50'si işbu sözleşmenin tebliğine istinaden peşin ve kalan 50% mal tesliminden 60 gün sonra ………...……… tarihinde TL bazında banka havalesiyle peşin",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "ödenecektir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "5- Vadesinde yapılmayan ödemelerde, aylık % 9 faiz işletilir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "6- İşbu siparişin verilmesi ile alıcı taraf, satın aldığı ürünlerin bedellerinin vadesi hakkında ihtar edilmiş olur. Karşı taraf, vade tarihinde borcunu ödemediği takdirde kendisine",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "ek bir ihtar yapılması gerekmeksizin temerrüde düşer ve satıcı temerrüt faizine hak kazanır. (TTK 1530/2)	",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "7- İş bu belge taraflar arasındaki mutakabat sonucunda oluşturulan nihai sözleşmedir. Alıcı siparişin durumunda ve adetlerinde, modellerde değişiklik yapamaz. Ancak bazı",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "durumlarda satıcının yazılı onayına istinaden değişiklikler satıcı insiyatifinde kabul edilebilir.	",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      autoHeight: true,
      data: {
        value:
          "8- Alıcı, iş bu sözleşme ile satıcının sipariş konusu ürünleri üretime başlayacağını, ham madde teminini yapacağını ve üretim planlamasını bu sipariş doğunda güncellediğini .",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      autoHeight: true,
      data: {
        value:
          "bilmektedir. Sipariş konusu ürünleri almaktan hiçbir koşulda vazgeçmeyeceğini, sözleşmeden dönmeyeceğini, bu maddeye aykırı davranması halinde ya da ilerleyen süreçte ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      autoHeight: true,
      data: {
        value:
          "siparişin bir kısmını almaktan vazgeçmesi halinde verilen kaparonun yanacağını, hiçbir şekilde geri istenemeyeceğini, ayrıca satıcının doğacak tüm zararlarını ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      autoHeight: true,
      data: {
        value: "karşılayacağını peşinen kabul ve taahhüt etmiştir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "9- Alıcı tarafından satıcıya bu sözleşmenin imzalanmasından sonra 4. Maddedeki bedel ödenir. 1. Madde uyarınca sipariş iptali mümkün değildir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "10- Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik ya da ayıp bulunması durumunda, alıcı 15 gün içerisinde bu durumu satıcıya bildirecektir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "Teslimden itibaren 15 gün sonrasında teslim edilen ürünler bu neden ile iade edilemeyecek, gizli ayıp haricinde ihbarda bulunulamayacaktır.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "11- İş bu proforma faturada yer alan birim fiyatları 15.01.2023 tarihine kadar toplam sipariş bedelinin nakden ve peşinen ödenmesi halinde geçerlidir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "Proforma fatura geçerlilik tarihi olan 15.01.2023 tarihinden sonra toptan fiyatlar mevcut piyasa koşullarına göre değişebilir. Bu tarihe kadar alıcı siparişinde değişiklik yapabilir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "Değişiklik eğer satıcının politikalarına aykırı ise satıcı siparişi tek taraflı olarak iptal edebilir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "9- 09.03.2023 tarihine kadar toplam sipariş bedeli nakden ödenmemiş siparişlerde sabit fiyat garantisi sunulmayacaktır.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "13- 15.01.2023 tarihine kadar nakden ödemesi yapılmamış siparişler için satıcı sevkiyatlara başlamadan önce 25.03.2022 tarihinde proforma faturadaki ürünler için toptan fiyat  ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "listesi yayınlanacaktır. Bu listede piyasa şartları gereği toptan ve tavsiye edilen perakende fiyatlar değişiklik gösterebilir. 25.03.2023 listesine göre siparişteki ürünlerin fiyatları ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "değişebilir. Alıcı bu durumu peşinen kabul etmektedir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "14- Satıcı değişen fiyat listelerinde, alıcının  toptan ve  tavsiye edilen perakande fiyatlar arasındaki birim kar marjını korumayı tahahhüt eder.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "Bu birim kar marjları 14.9.2022 tarihli fiyat listelerindeki marjlardır.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value:
          "15- Mücbir sebep halleri olan yangın,sel, deprem, salgın hastalık,doğal afetler kaynaklı işletmede ve tedarik zincirinde işlerin kısmen ve tamamiyle yapılamaması halinde  ",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "teslimat tarihleri revize edilebilir. Bunu alıcı peşinen kabul etmiştir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading2",
      data: {
        value: "16- İhtilaf halinde Denizli Mahkemeleri ve İcra Daireleri yetkilidir.",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "BANKA:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "T. VAKIFLAR BANKASI T.A.O. ",
        type: "String",
      },
      mergeAcross: 2,
    },
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 7,
    },
  ],
  [
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "ŞUBE:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "DENIZLI – SARAYKÖY ŞUBESİ",
        type: "String",
      },
      mergeAcross: 2,
    },
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 7,
    },
  ],
  [
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "HESAP SAHİBİ:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "DÖNMEZ EV TEKSTİLİ VE GİYİM SANAYİ A.Ş.",
        type: "String",
      },
      mergeAcross: 2,
    },
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 7,
    },
  ],
  [
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "IBAN:",
        type: "String",
      },
      type: "String",
    },
    {
      styleId: "coverHeadingBorder",
      data: {
        value: "TR74 0001 5001 5800 7314 6893 61",
        type: "String",
      },
      mergeAcross: 2,
    },
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 7,
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 3,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: "SATICI",
        type: "String",
      },
      mergeAcross: 3,
      type: "String",
    },
    {
      styleId: "coverHeading",
      data: {
        value: "ALICI",
        type: "String",
      },
      mergeAcross: 2,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
  [
    {
      styleId: "coverHeading",
      data: {
        value: "",
        type: "String",
      },
      mergeAcross: 11,
      type: "String",
    },
  ],
];

const getParams = () => {
  const obj = {
    headerFooterConfig: {
      all: {},
    },
    prependContent: [],
    appendContent: [],
    addImageToCell: {},
    rowHeight: (params) => {
      let deger = ((params.rowIndex - 13) / 85).toString();
      return params.rowIndex === 1 ||
        params.rowIndex % 85 == 1 ||
        deger.includes(".") == false
        ? 120
        : 20;
    },

    processHeaderCallback(params) {
      return ` ${params.columnApi.getDisplayNameForColumn(params.column, null)}`;
    },

    getCustomContentBelowRow(params) {
      if (params.node.id % 70 === 69) {
        return getRowsHeader(params);
      }
    },
  };

  obj.addImageToCell = (rowIndex, col, value) => {
    if (value != null && typeof value != undefined) {
      if (value.toString().includes("data:image/png") === true) {
        return {
          image: {
            id: "logo",
            base64: value,
            imageType: "png",
            width: 295,
            height: 100,
            position: {
              colSpan: 3,
            },
          },
        };
      }
    }
    return;
  };

  obj.headerFooterConfig.all.footer = [
    {
      value: "1",
    },
  ];
  obj.prependContent = getRows();
  if (userJson.excelSartlar == true) obj.appendContent = getRowsF();
  return obj;
};
const ItemListView = () =>
  import("../components/b2b-components/products-components/ItemListView.vue");
export default {
  data() {
    return {
      orderListColumn: [],
      rowClassRules: null,
      orderListClmn: null,
      kalemAdet: 0,
      toplamAdet: 0,
      toplamSipTutar: 0.0,
      toplamSipTutarKDV: 0.0,
      toplamPerakende: 0.0,
      pinnedBottomRowData: null,
      popupParent: null,
      defaultExcelExportParams: null,
      excelStyles: null,
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      sevkAdi: "",
      ExcelDataName: "",
      ROL: "",
      aylar: [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ],
      sistemurl: Store.state.imgurl,
      dir: false,
      checkSelected: "",
      arananDetayDegeri: "",

      datepickerbaslangic: "",
      placeholderbaslangic: "",
      datepickerbitis: "",
      placeholderbitis: "",
      arananDeger: "",
      siparisRefNo: "",
      popupKartDetay: false,
      arananDeger: "",
      orderList: [],
      orderListDetay: [],
      kargoBilgisi: [],
      kargoDurumu: [],

      kargoTakipKodu: "",
      karkoTakipUrl: "",
      kargoDurumu: "",
      kargoyaVerilisTarihi: "",
      durumGuncellenmeTarihi: "",
      teslimatSeriNumarasi: "",

      kargoAdres: "",
      kargoAd: "",
      kargoIl: "",
      kargoIlce: "",
      teslimatTipi: "",
      odemeTipi: "",
      toplamTutar: "",
      toplamkgDesi: "",
      actnamee: "",
      adress: "",
      taxnumber: "",
      taxnumb: "",

      dataFormat: [],
      orderListFExcel: [],
      orderDetailList: [],
    };
  },
  components: {
    OrdersPdf,
    OrderDetailCellRenderer,
    KdvliFiyatCellRenderer,
    TextGorunumCellRenderer,
    UrunResimCellRenderer,
    ItemListView,
    AgGridVue,
  },
  methods: {
    excelIndir() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var selectedRows = vm.gridApi.getSelectedRows();
      let barkodesLc = ""; 
      if (selectedRows.length > 0) {
        selectedRows.forEach((val, index) => {
          barkodesLc += "'" + val.OrderNumber + "'";
          if (index == selectedRows.length - 1) {
          } else barkodesLc += ",";
        }); 

        const args = {
          token: Store.state.tokenId,
          barcodes: barkodesLc.trim(),
          isDue: "OrderItems",
        };

        soap.createClient(url, function (err, client) {
          client.B2B_OrderList(args, function (err, result) { 
            let list = JSON.parse(result.B2B_OrderListResult); 
            vm.orderListFExcel = list;
            const headers = Object.keys(vm.orderListFExcel[0]);

            // Başlıkları ve veri satırlarını bir araya getirme
            const ws_data = [
              headers, // Başlıklar
              ...vm.orderListFExcel.map((row) => headers.map((header) => row[header])), // Veri satırları
            ];

            // Worksheet oluşturma
            const ws = XLSX.utils.aoa_to_sheet(ws_data);

            // Workbook oluşturma
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

            // Dosyayı indir
            XLSX.writeFile(wb, barkodesLc.trim() + ".xlsx");
          });
        });
      } else {
        var vs = this.$vs;
        vs.notify({
          text: "Seçim yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warnin",
          position: "top-center",
        });
      }
    },
    createData() {
      var result = [];
      result.push({
        grup: "",
        maddeKodu: this.kalemAdet,
        maddeAciklamasi: "",
        renkAciklamasi: "",
        BEDEN: "",
        icerik: "",
        MIKTAR: this.toplamAdet,
        FIYAT: this.topBAKIYE,
        FIYATKDV: "",
        TUTAR: this.toplamSipTutar,
        TUTARKDV: this.toplamSipTutarKDV,
        carpan: "",
        perakendeFiyat: "",
      });

      return result;
    },
    onBtPdf() {
      this.$refs.siparisCek.siparisDetayCek(
        this.orderListDetay,
        this.siparisRefNo,
        this.actnamee,
        this.adress,
        this.taxnumber,
        this.toplamAdet,
        this.toplamSipTutar,
        this.toplamSipTutarKDV,
        this.taxnumb
      );
    },

    onBtExport() {
      this.gridApi2.exportDataAsExcel(getParams());
    },

    getYear(date) {
      var formatted = new Date(date);
      var rdate = formatted.getFullYear();
      return rdate;
    },
    getMounth(date) {
      var formatted = new Date(date);
      var rdate = formatted.getMonth() + 1;
      return this.aylar[rdate - 1];
    },
    getDay(date) {
      var formatted = new Date(date);
      var rdate = formatted.getDate();
      return rdate;
    },
    currencyFormatter(currency) {
      var parfloat = parseFloat(currency);

      if (typeof currency == "undefined" || currency == null) return "";
      else {
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "₺" + `${formatted}`;
      }
    },
    isMobile: function () {
      /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
      return isMobile;
    },
    getShipDetay() {},
    getLastSixMonth() {
      var d = new Date();
      const date = d.getFullYear() + "-" + (d.getMonth() - 6) + "-" + d.getDate();
      const dateTime = date;
      return dateTime;
    },
    getNow() {
      const today = new Date();
      const date =
        today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

      const dateTime = date;
      return dateTime;
    },
    parseDate(params) {
      if (typeof params == "object") return "";
      return moment(String(params)).format("DD.MM.YYYY");
    },
    parseCurrency(gelen) {
      var gelenfloat = parseFloat(gelen);
      return gelenfloat.toLocaleString("tr-TR", {
        style: "currency",
        currency: "TRY",
      });
    },
    getTableSort() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        module: "orderDetailList",
        isDue: "listForModule",
      };
      soap.createClient(url, function (err, client) {
        client.B2B_TABLES_SORT(args, function (err, result) {
          vm.veriler = JSON.parse(result.B2B_TABLES_SORTResult);
          vm.orderDetailList = vm.veriler;
        });
      });
    },
    generateColumnDefs(rowData, columnDefs) {
      if (rowData.length > 0) {
        this.orderListColumn = columnDefs
          .map((item) => item.Item1)
          .map((key) => {
            const isEmpty = rowData.every(
              (row) =>
                row[key] === "" ||
                row[key] === 0 ||
                row[key] == null ||
                key == "barcode" ||
                key == "KAYITSAYISI" ||
                key == "images" ||
                key == "page" ||
                key == "stockCode" ||
                key == "count" ||
                key == "image" ||
                key == "unit"
            );

            return isEmpty
              ? null
              : {
                  headerName: this.$t(key),
                  field: key,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellRenderer: "TextGorunumCellRenderer",
                };
          })
          .filter((colDef) => colDef !== null);
      }
    },
    getOrderListDetay(item) { 
      this.dataFormat = [];
      var vm = this;
      vm.orderListDetay = [];
      if (item.sevkAdi != "") vm.sevkAdi = item.sevkAdi;
      this.$refs["modal-primary "].show();
      vm.siparisRefNo = item.OrderNumber;
      siparisRefNo = vm.siparisRefNo;
      ACT_NAME = item.actname;
      vm.actnamee = item.actname;
      vm.adress = item.adres;
      vm.taxnumber = item.taxnumber;
      vm.taxnumb = item.taxnumb;

      taxnumberF = item.taxnumber;
      taxnumbF = item.taxnumb;
      let deger = moment(String(item.OrderDate)).format("DD-MM-YYYY");
      OrderDateF = deger;
      adresF = item.adres;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        OrderNumber: item.OrderNumber,
        token: Store.state.tokenId,
        aranan: vm.arananDetayDegeri,
        cariKod: item.ACT_ID,
        adresId: item.adres_Id,
        ONAY: item.ONAY,
      };

      soap.createClient(url, function (err, client) {
        client.B2B_OrderListDetay(args, function (err, result) {
          if (result.B2B_OrderListDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.B2B_OrderListDetayResult);
            vm.orderListDetay = vm.veriler;
            vm.ExcelDataName = item.OrderNumber;
            vm.toplamAdet = 0;
            vm.toplamSipTutar = 0.0;
            vm.toplamSipTutarKDV = 0.0;
            vm.toplamPerakende = 0.0;
            vm.kalemAdet = 0;

            vm.orderListDetay.forEach((val, index) => {
              vm.toplamAdet += parseFloat(val.MIKTAR);
              vm.toplamSipTutar += parseFloat(val.TUTAR);
              vm.toplamSipTutarKDV += parseFloat(val.TUTARKDV);
              vm.toplamPerakende += parseFloat(val.perakendeFiyat);
              vm.kalemAdet = index + 1;
            });

            vm.pinnedBottomRowData = vm.createData(1, "Bottom");

            let columnList = vm.orderDetailList; 
            vm.orderListColumn = [];
       //     vm.generateColumnDefs(vm.orderListDetay, vm.orderDetailList);

            columnList.forEach((val, index) => {
              if (val.Item1 == "image") {
                vm.orderListColumn.push({
                  width: 120,
                  headerName: val.Item2,
                  field: val.Item1,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellClass: "textType",
                  cellRenderer: "ProductListStokResim",
                  pinned: "left",
                });
              } else if (val.Item1 == "barcode") {
                if (vm.varyantlimi == "true")
                  vm.orderListColumn.push({
                    headerName: val.Item2,
                    field: val.Item1,
                    filter: "agSetColumnFilter",
                    wrapText: true,
                    autoHeight: true,
                    cellClass: "textType",
                    cellRenderer: "TextGorunumCellRenderer",
                    pinned: "left",
                  });
              } else if (val.Item1 == "maddeKodu" || val.Item1 == "maddeAciklamasi") {
                vm.orderListColumn.push({
                  headerName: val.Item2,
                  field: val.Item1,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellClass: "textType",
                  cellRenderer: "TextGorunumCellRenderer",
                  pinned: "left",
                });
              } else {
                vm.orderListColumn.push({
                  headerName: val.Item2,
                  field: val.Item1,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellClass: "textType",
                  cellRenderer: "TextGorunumCellRenderer",
                  
                });
              }
            }); 

          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    kargoDurumSorgula() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        orderNumber: vm.sevkAdi,
        kargo: "MNG",
      };
      soap.createClient(url, function (err, client) {
        client.kargoDurumu(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.kargoDurumuResult);
            vm.kargoDurumu = vm.veriler;

            vm.kargoTakipKodu = vm.veriler[0].referenceId;
            vm.karkoTakipUrl = vm.veriler[0].trackingUrl;
            vm.kargoDurumu = vm.veriler[0].shipmentStatus;
            vm.kargoyaVerilisTarihi = vm.veriler[0].shipmentDateTime;
            vm.durumGuncellenmeTarihi = vm.veriler[0].statusDateTime;
            vm.teslimatSeriNumarasi = vm.veriler[0].shipmentSerialandNumber;
          } catch (error) {
            console.log(result);
          }
        });
      });
      soap.createClient(url, function (err, client) {
        client.kargoBilgisi2(args, function (err, result) {
          try {
            vm.veriler1 = JSON.parse(result.kargoBilgisi2Result);
            vm.kargoBilgisi2 = vm.veriler1[0];
            vm.kargoAdres = vm.veriler1[0].recipient.address;
            vm.kargoAd = vm.veriler1[0].recipient.fullName;
            vm.kargoIl = vm.veriler1[0].recipient.city;
            vm.kargoIlce = vm.veriler1[0].recipient.district;
            vm.teslimatTipi = vm.veriler1[0].shipment.deliveryType;
            vm.odemeTipi = vm.veriler1[0].shipment.paymentType;
            vm.toplamTutar = vm.veriler1[0].shipment.total;
            vm.toplamkgDesi = vm.veriler1[0].shipment.totalKgDesi;
          } catch (error) {
            console.log(error);
            console.log(result);
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady2(params) {
      this.gridApi2 = params.api;
      this.gridColumnApi2 = params.columnApi;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getOrderList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      /*
      if (
        vm.datepickerbaslangic == "" ||
        vm.datepickerbaslangic == "Invalid date"
      ) {
        baslangic = vm.getLastSixMonth();
        vm.datepickerbaslangic = baslangic;
      } else baslangic = vm.datepickerbaslangic;
      if (vm.datepickerbitis == "" || vm.datepickerbitis == "Invalid date") {
        bitis = vm.getNow();
        vm.datepickerbitis = bitis;
      } else bitis = vm.datepickerbitis;
*/
      const args = {
        cariKod: state.UserId,
        token: Store.state.tokenId,
        basTarih: vm.datepickerbaslangic,
        bitTarih: vm.datepickerbitis,
        ROL: vm.ROL,
      };
      soap.createClient(url, function (err, client) {
        client.B2B_OrderList(args, function (err, result) {
          if (result.B2B_OrderListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.B2B_OrderListResult);
            vm.orderList = vm.veriler;
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
  },
  created() {
    this.getTableSort();
    this.ROL = Store.state.ROL;
    this.getOrderList();

    this.popupParent = document.body;
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "multiple";

    this.defaultExcelExportParams = {
      headerRowHeight: 120,
    };
    this.rowClassRules = {
      // row style function
      "bg-danger": (params) => {
        var numSickDays = params.data.DurumId;
        return numSickDays == "1";
      },
      "bg-success": (params) => {
        var numSickDays = params.data.DurumId;
        return numSickDays == "2";
      },
    };
    this.excelStyles = [
      {
        id: "tarihHeading",
        alignment: {
          horizontal: "Right",
        },
        font: {
          bold: true,
        },
        borders: {
          borderTop: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderBottom: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderRight: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderLeft: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },
      {
        id: "multiline",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
          wrapText: true,
        },
        borders: {
          borderRight: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },

      {
        id: "imageStyle",
        borders: {
          borderLeft: {
            color: "#fffff",
          },
        },
      },
      {
        id: "header",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
          wrapText: true,
        },
        interior: {
          color: "#f8f8f8",
          pattern: "Solid",
          patternColor: undefined,
        },

        font: {
          bold: true,
        },
        borders: {
          borderRight: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 1,
          },
        },
      },
      {
        id: "coverHeading3",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
          wrapText: true,
        },
        font: {
          bold: true,
        },

        dataType: "String",
        borders: {
          borderTop: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderBottom: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderRight: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderLeft: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },
      {
        id: "coverHeadingBorder",
        alignment: {
          vertical: "Center",
          horizontal: "Left",
        },
        font: {
          bold: true,
        },
        borders: {
          borderTop: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderBottom: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderRight: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 1,
          },
          borderLeft: {
            color: "#7c6144",
            lineStyle: "Continuous",
            weight: 1,
          },
        },
        dataType: "String",
      },
      {
        id: "coverHeading",
        alignment: {
          vertical: "Center",
          horizontal: "Left",
          wrapText: true,
        },
        font: {
          bold: true,
        },

        dataType: "String",
        borders: {
          borderTop: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderBottom: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderRight: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderLeft: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },
      {
        id: "coverHeading2",
        dataType: "String",
        borders: {
          borderTop: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderBottom: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderRight: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderLeft: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },
      {
        id: "coverHeading2",
        dataType: "String",
        borders: {
          borderTop: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderBottom: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderRight: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
          borderLeft: {
            color: "#FFFFFF",
            lineStyle: "Continuous",
            weight: 0,
          },
        },
      },
      {
        id: "textType",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
          wrapText: true,
        },
        dataType: "String",
      },
      {
        id: "cells",
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
        dataType: "String",
      },
      {
        id: "numberType",
        numberFormat: {
          format: "0",
        },
        alignment: {
          vertical: "Center",
          horizontal: "Center",
        },
      },
    ];
  },
  mounted() {
    this.$root.$on("getOrderListDetay", (params) => {
      this.getOrderListDetay(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("getOrderListDetay");
  },
  beforeMount() {
    this.orderListClmn = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellRenderer: "OrderDetailCellRenderer",
        width: 150,
      },
      {
        headerName: "Durum",
        field: "ONAY",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,

        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Sipariş Numarası",
        field: "OrderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,

        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "B2B-Sip No",
        field: "Desctription",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,

        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Unvan",
        field: "ACT_NAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        hide: this.ROL == "ADMIN" ? false : true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Sipariş Tarihi",
        field: "OrderDate",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.parseDate(params.data.OrderDate),
      },
      {
        headerName: "Toplam Adet",
        field: "TOTALQUANTITY",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Tamamlanan Adet",
        field: "COMPLATEQUANTITY",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },

      {
        headerName: "Sipariş Tutarı (KDV Dahil)",
        field: "TOTAL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        /*       valueFormatter: (params) =>
          new Intl.NumberFormat("tr-TR",
            { style: "currency", currency: "TRY" }).format(parseFloat(params.data.TOTAL.toString().replace(',',
              '.')))*/
      },
      {
        headerName: "KDV Tutarı ",
        field: "VATTOTAL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(
            parseFloat(params.data.VATTOTAL.toString().replace(",", "."))
          ),
      },
      {
        headerName: "İskontolu Tutar (KDV Dahil)",
        field: "DISCOUNTPRICE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(
            parseFloat(params.data.DISCOUNTPRICE.toString().replace(",", "."))
          ),
      },
      {
        headerName: "Toplam Tutar (KDV DAHİL)",
        field: "COMPLATETOTAL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Vade",
        field: "Vade",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.parseDate(params.data.Vade),
      },
      {
        headerName: "Açıklama",
        field: "Desctription",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
    ];
    /*
    this.orderListColumn = [
        {
        width: 100,
        field: "",
        cellRendererFramework: "UrunResimCellRenderer",
      },
      {
        headerName: "Grup",
        field: "grup",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Barkod",
        field: "maddeKodu",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "numberType",
      },

      {
        headerName: "Stok Kodu",
        field: "siparisRefNo",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "numberType",
      },
      {
        headerName: "Stok Adı",
        field: "maddeAciklamasi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
      {
        headerName: "Renk",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "renkAciklamasi",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
      {
        headerName: "Beden",
        field: "BEDEN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
      
      {
        headerName: "İçerik",
        field: "icerik",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "textType"
      },
      {
        headerName: "Sipariş\n Adedi",
        field: "MIKTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
      {
        headerName: "Toptan\n Satış \nFiyatı TL \n(KDV HARİÇ)",
        field: "FIYAT",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },

      {
        headerName: "Toptan \nSatış \nFiyatı TL \n(KDV DAHİL)",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "FIYATKDV",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Toptan\n Sipariş \nTutarı \n(KDV HARİÇ)",
        sortable: true,
        field: "TUTAR",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Toptan Sipariş Tutarı (KDV DAHİL)",
        sortable: true,
        field: "TUTARKDV",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "İskontolu Tutarı (KDV Dahil)",
        field: "DISCOUNTPRICE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(
            parseFloat(params.data.DISCOUNTPRICE.toString().replace(",", "."))
          ),
      },
      
      {
        headerName: "Çarpan",
        sortable: true,
        field: "carpan",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
      {
        headerName: "PERAKENDE SATIŞ FİYATI",
        sortable: true,
        field: "perakendeFiyat",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        wrapText: true,
        autoHeight: true,
        cellClass: "textType",
      },
    ];*/
  },
};
</script>

<style lang="scss">
.bg-success {
  background-color: #acfcd0 !important;
}

.bg-danger {
  background-color: #f8cbcc !important;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}

table.vgt-table {
  font-size: small;
}

.vs-tabs-position-left .con-ul-tabs {
  margin: 10px;
}

:root {
  /* default value */
  --main-bg-color: brown;
}

[dir] blockquote {
  border-left-color: var(--main-bg-color) !important;
}
</style>
